import { Reward } from '@/models';
import { AnalyticsEvent } from '../models';

export class AccountPageLoadEvent implements AnalyticsEvent {
  name = 'AccountPageLoadEvent';

  constructor(public readonly eventType: string, public readonly reward?: Reward) { }
}